import { z } from 'zod';

// コメントいいねリクエスト型
export interface CommentLikeRequest {
  comment_id: string;
}

// コメントいいね作成レスポンス
export const CommentLikeResponseSchema = z.object({
  message: z.string(),
  commentLike: z.object({
    comment_id: z.string().or(z.number()),
    user_id: z.string(),
    created_at: z.string()
  })
});
export type CommentLikeResponse = z.infer<typeof CommentLikeResponseSchema>;

// コメントいいね削除レスポンス
export const CommentUnlikeResponseSchema = z.object({
  message: z.string()
});
export type CommentUnlikeResponse = z.infer<typeof CommentUnlikeResponseSchema>;

// コメントいいね数レスポンス
export const CommentLikesCountResponseSchema = z.object({
  comment_id: z.string().or(z.number()),
  likesCount: z.number()
});
export type CommentLikesCountResponse = z.infer<typeof CommentLikesCountResponseSchema>;

// いいねユーザー情報
export const UserSchema = z.object({
  id: z.string(),
  name: z.string(),
  icon_path: z.string().nullable()
});
export type User = z.infer<typeof UserSchema>;

// コメントいいねユーザー一覧レスポンス
export const CommentLikersResponseSchema = z.object({
  comment_id: z.string().or(z.number()),
  likers: z.array(UserSchema)
});
export type CommentLikersResponse = z.infer<typeof CommentLikersResponseSchema>;

// コメントいいね状態レスポンス
export const CommentLikeStatusResponseSchema = z.object({
  liked: z.boolean()
});
export type CommentLikeStatusResponse = z.infer<typeof CommentLikeStatusResponseSchema>; 